import axios from 'axios'
axios.defaults.baseURL = 'https://saastest.xinfu.info/xinfu/';
// axios.defaults.baseURL = 'http://localhost:9000';
var res = ""
const service = axios.create({
    // 请求超时时间
    timeout: 10000,
    withCredentials: true,
    headers: {
        "Authorization": res,
        "Ac-ch-xf": "c4ca4238-a0b9-2382-0dcc-509a6f75849b",
    }
});
service.interceptors.request.use(
    config => {
        res = ""
        var arrstr = document.cookie.split("; ");
        for (var i = 0; i < arrstr.length; i++) {
            var temp = arrstr[i].split("=");
            if (temp[0] == "XF_L_T") {
                res = temp[1]
            } else if (temp[0] == "JSESSIONID") {
                res = temp[1]
            }
        }
        return config
    },
    err => {
        window.console.log(err)
    }
);
service.interceptors.response.use(
    response => {
        let res = {};
        res.status = response.status;
        res.data = response.data;
        res.origin = response;
        return res
    },
    err => window.console.log(err)
);
export default service
